<template>
	<v-app id="main" :style="style">
		<!-- <v-overlay :value="overlay" opacity=".9" z-index="10">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>-->

		<MainMenu v-if="showMenu" />
		<v-main>
			<Announcement v-if="showMenu"></Announcement>

			<v-banner
				v-if="deferredPrompt && $store.getters.retrieveHomeScreenPrompt"
				color="blue darken-2"
				dark
				class="text-left"
				app
			>
				Would you like to install our application to your desktop?
				<template v-slot:actions>
					<v-btn text @click="dismiss">Dismiss</v-btn>
					<v-btn outlined @click="install">Install</v-btn>
				</template>
			</v-banner>

			<v-banner
				v-if="
					isMobileSafari &&
					!isInStandaloneMode &&
					$store.getters.retrieveHomeScreenPrompt
				"
				color="grey lighten-3"
				class="text-left"
			>
				<v-icon slot="icon" color="grey darken-1" size="36"
					>mdi-plus-box</v-icon
				>
				<div>
					Install this webapp on your device: tap
					<v-img
						contain
						width="24px"
						height="24px"
						:src="
							require('@/assets/icons/ios_navigation_action_blue.png')
						"
						style="
							max-width: 26px;
							display: inline-block;
							margin-right: 2px;
						"
					/>and then "Add to Home Screen"
				</div>
				<template v-slot:actions>
					<v-btn
						color="blue darken-2"
						text
						@click="setShowPrompt(false)"
						>Dismiss</v-btn
					>
				</template>
			</v-banner>

			<v-row
				justify="space-between"
				align="start"
				no-gutters
				:class="{ borderBottom: hasBreadcrumbs }"
			>
				<v-col cols="12" md="6">
					<Breadcrumbs
						v-if="hasBreadcrumbs && !retrieveGuest"
					></Breadcrumbs>
				</v-col>
				<v-col cols="12" md="3" class="hidden-sm-and-down">
					<SocialMedia v-if="showMenu"></SocialMedia>
				</v-col>
			</v-row>
			<v-container grid-list-md fluid>
				<keep-alive>
					<router-view class="py-0"></router-view>
				</keep-alive>
			</v-container>
		</v-main>

		<v-snackbar
			v-model="snackbar.showing"
			:timeout="snackbar.timeout"
			:color="snackbar.color"
			multi-line
		>
			{{ snackbar.text }}
			<slot v-if="snackbar.text2">
				<br />
				<strong>Warning: </strong> {{ snackbar.text2 }}
			</slot>
			<template v-slot:action="{ attrs }">
				<v-btn text v-bind="attrs" @click="resetSnackbarDefault()">{{
					snackbar.btnText
				}}</v-btn>
			</template>
		</v-snackbar>

		<v-snackbar
			elevation="24"
			v-model="snackbarStatic.showing"
			:timeout="-1"
			:color="snackbarStatic.color"
			multi-line
			vertical
			centered
		>
			<div class="subtitle-2">
				<v-icon>info</v-icon>
				<span class="pl-2">Important Information</span>
			</div>

			<div class="pt-4">{{ snackbarStatic.text }}</div>

			<template v-slot:action="{ attrs }">
				<v-btn text v-bind="attrs" @click="resetSnackbar()"
					>Close</v-btn
				>
			</template>
		</v-snackbar>

		<Footer />
	</v-app>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";

import MainMenu from "@/components/layout/MainMenu.vue";
import Announcement from "@/components/layout/Announcement.vue";
import Breadcrumbs from "@/components/layout/Breadcrumbs.vue";
import SocialMedia from "@/components/layout/SocialMedia.vue";

import Footer from "@/components/layout/Footer.vue";

export default {
	name: "App",
	components: {
		MainMenu,
		Announcement,
		Breadcrumbs,
		SocialMedia,
		Footer,
	},

	data: () => ({
		// overlay: false

		//Test PWA
		deferredPrompt: null,
	}),

	beforeCreate() {
		if (
			process.env.VUE_APP_CATERPOINT == "https://adavid.caterpoint.co.uk"
		) {
			//force redirect Arthur Davids customers to new site
			location.assign("https://arthurdavidonline.co.uk/");
		}

		if (
			process.env.VUE_APP_CATERPOINT ==
			"https://accentfresh.caterpoint.co.uk"
		) {
			//force redirect Accent Fresh customers to new site
			location.assign("https://cp3-online-accentfresh.caterpoint.co.uk/");
		}

		if (
			process.env.VUE_APP_CATERPOINT ==
			"https://adavid-test.caterpoint.co.uk"
		) {
			//force redirect Test Arthur Davids test site to new test site
			location.assign("https://cp3-online-adavid-test.caterpoint.co.uk/");
		}

		if (
			process.env.VUE_APP_CATERPOINT ==
			"https://delifresh.caterpoint.co.uk"
		) {
			//force redirect Delifresh customers to new site
			location.assign("https://cp3-online-delifresh.caterpoint.co.uk/");
		}

		if (
			process.env.VUE_APP_CATERPOINT ==
			"https://threshfield.caterpoint.co.uk"
		) {
			//force redirect Threshfields customers to new site
			location.assign(
				"https://cp3-online-threshfield.caterpoint.co.uk//"
			);
		}

		if (process.env.VUE_APP_HOME_NAME) {
			document.title = process.env.VUE_APP_HOME_NAME;
		} else if (process.env.VUE_APP_COMPANY_NAME) {
			document.title = process.env.VUE_APP_COMPANY_NAME;
		}
	},

	async created() {
		// this.overlay = true;
		await this.getConfigs();
		// this.overlay = false;

		//Test PWA
		window.addEventListener("beforeinstallprompt", (e) => {
			console.log("-- Install Prompt");
			e.preventDefault();
			// Stash the event so it can be triggered later.
			this.deferredPrompt = e;
		});

		window.addEventListener("appinstalled", () => {
			console.log("-- App Installed");
			this.deferredPrompt = null;
		});

		console.log("-- Checking Dashboard env");
		console.log(this.$store.getters.retrieveDashboardHomePage);
		console.log(process.env.VUE_APP_DASHBOARD_DEFAULT);

		if (
			this.$store.getters.retrieveDashboardHomePage == null &&
			process.env.VUE_APP_DASHBOARD_DEFAULT == "true"
		) {
			console.log("-- Has Dashboard env");
			this.setDashboardHomePage(true);
		} else {
			console.log("-- No Dashboard env");
			this.setDashboardHomePage(false);
		}
	},

	mounted() {
		this.resetSnackbar();
		this.resetSnackbarDefault();

		// if ("serviceWorker" in navigator) {
		//   navigator.serviceWorker
		//     .register("/service-worker.js")
		//     .then(reg => {
		//       console.log("Registration succesful, scope: " + reg.scope);
		//     })
		//     .catch(err => {
		//       console.log(err);
		//     });
		// }

		if (this.$store.getters.retrieveCustomTheme) {
			//We Are using a custom theme so get the details and load them
			console.log("-- Apply Custom Theme");
			this.setVuetifyTheme(
				this.$store.getters.retrieveCustomThemeDetails
			);
		} else {
			//We're not so revert to standard Caterpoint theme
			console.log("-- Apply Caterpoint Theme");
			this.setVuetifyTheme(
				this.$store.getters.retrieveCaterpointThemeDetails
			);
		}

		console.log(this.$route.query);
	},

	computed: {
		...mapState(["snackbar"]),
		...mapGetters(["retrieveGuest"]),

		isMobileSafari() {
			return (
				navigator.userAgent.match(/(iPod|iPhone|iPad)/) &&
				navigator.userAgent.match(/AppleWebKit/)
			);
		},

		pageWidth() {
			let style = {};

			if (this.$vuetify.breakpoint.mdAndUp) {
				// style["padding-left"] = "80px";
				// style["padding-right"] = "80px";

				// style["max-width"] = "1400px";

				style["--contentWidth"] = "1400px";
				style["background"] = "lightcoral";
				style["padding"] =
					"2rem calc((100% - var(--contentWidth)) / 2)";
			}

			return style;
		},

		isInStandaloneMode() {
			console.log("-- Checking Stuff");
			console.log(window.navigator);
			console.log(window.navigator.standalone);
			return (
				"standalone" in window.navigator && window.navigator.standalone
			);
		},

		snackbarStatic() {
			return this.$store.getters["snackbarStatic/retrieveSnackbar"];
		},

		theme() {
			console.log(this.$vuetify.theme);
			return this.$vuetify.theme.dark ? "dark" : "light";
		},

		style() {
			const Style = {
				background: this.$vuetify.theme.themes[this.theme].background,
				color: this.$vuetify.theme.themes[this.theme].color,
			};

			return Style;
		},

		showMenu() {
			return this.$route.meta.showMenu;
		},

		hasBreadcrumbs: function () {
			let breadCrumbLength = 0;

			if (this.$route.meta.breadCrumbs) {
				breadCrumbLength = this.$route.meta.breadCrumbs.length;
			}

			return breadCrumbLength;
		},
	},

	methods: {
		...mapActions([
			"getConfigs",
			"setHomeScreenPrompt",
			"setCustomTheme",
			"setVuetifyTheme",
			"setDashboardHomePage",
			"resetSnackbarDefault",
		]),
		...mapActions("snackbarStatic", ["resetSnackbar"]),

		//Test PWA
		async dismiss() {
			this.deferredPrompt = null;
			await this.setHomeScreenPrompt(false);
		},

		async install() {
			this.deferredPrompt.prompt();
		},

		async setShowPrompt(value) {
			console.log(" -- Setting Dark Theme");
			await this.setHomeScreenPrompt(value);
		},
	},
};
</script>

<style lang="sass">
@import '~vuetify/src/styles/styles.sass'

a
  text-decoration: none

.v-application a
  color: var(--v-info-darken2)

.shrink
  flex-grow: 0.06 !important
  flex-shrink: 1 !important

.theme--light.v-banner.v-sheet .v-banner__wrapper, .theme--dark.theme--light.v-banner.v-sheet .v-banner__wrapper
  border: 0

.theme--dark.v-data-table, .theme--dark.v-expansion-panels .v-expansion-panel, .theme--dark.v-tabs > .v-tabs-bar, .theme--dark.v-tabs-items
  background: var(--v-background-base) !important

::-webkit-scrollbar
  width: 11px

body
  scrollbar-width: thin
  scrollbar-color: var(--v-scrollbarThumb-base) var(--v-scrollbarBackground-base)

::-webkit-scrollbar-track
  background: var(--v-scrollbarBackground-base)

::-webkit-scrollbar-thumb
  background-color: var(--v-scrollbarThumb-base)
  border-radius: 6px
  border: 3px solid var(--v-scrollbarBackground-base)

.v-stepper__header
  box-shadow: none !important

.container > div > .row, .container > .row
  --contentWidth: 1200px
  padding: 2rem calc((100% - var(--contentWidth)) / 2)
  padding-top: 0

.borderBottom
  border-bottom: 1px solid var(--v-menu_border_color-base) !important

.borderRight
  border-right: 1px solid var(--v-menu_border_color-base) !important

.borderTop
  border-top: 1px solid var(--v-menu_border_color-base) !important

.borderLeft
  border-left: 1px solid var(--v-menu_border_color-base) !important

.theme--light .dialogActions
  background-color: var(--v-background_off-base)
  border-top: 1px solid var(--v-background_off-darken1)
  border-bottom-right-radius: 4px
  border-bottom-left-radius: 4px

.theme--dark .dialogActions
  background-color: var(--v-background_off-base)
  border-top: 1px solid var(--v-background_off-lighten1)
  border-bottom-right-radius: 4px
  border-bottom-left-radius: 4px

.v-card
  color: var(--v-color-base) !important
  background-color: var(--v-background-base) !important
</style>
